<template>
  <div class="main_center" style="margin: 0 0;padding-top: 8px;">

    <div class="content" style="padding: 16px 16px 5px 16px;">

      <el-form ref="form" :model="form" label-width="85px">
        <el-row>
          <el-col :span="8" >
            <el-form-item label="业务类型："  props="busType">
              <el-select v-model="form.busType" clearable value-key="value" style="width:100%;" @change="seachBtn">
                <el-option v-for="(item,index) in businessTypeNamelist" :key="index" :label="item.name"
                           :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
<!--          <el-col :span="8" >
            <el-form-item label="分类节点：" props="classNode">
              <el-select v-model="form.classNode" clearable value-key="value" style="width:100%;" @change="seachBtn">
                <el-option v-for="(item,index) in classNodelist" :key="index" :label="item.name"
                           :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>-->
          <el-col :span="5">
            <el-form-item >
              <el-input v-model="form.search" clearable placeholder="请输入关键字搜索" @keydown.enter.native.stop="seachBtn"></el-input>
            </el-form-item>
          </el-col>
          <div style="float:right;">
<!--            <el-button size="mini" type="text" v-if="!moreSearchItem" @click="moreSearchItem = true"
                       icon="el-icon-arrow-down">展开
            </el-button>
            <el-button size="mini" type="text" v-if="moreSearchItem" @click="moreSearchItem = false"
                       icon="el-icon-arrow-up">收起
            </el-button>-->
            <el-button size="small" type="primary" @click="seachBtn">搜索</el-button>
            <el-button plain size="small" type="primary" @click="reflash">重置</el-button>
          </div>
        </el-row>
      </el-form>
      <div style="position: relative;top:-10px">
        <el-button size="small"  icon="el-icon-plus" type="primary"
                   v-if="hasBtnPermission('btn_jz_pm_dgwitness_busflow_configs_add')"
                   @click="routerAdd">新增</el-button>
        <el-button size="small" icon="el-icon-delete" type="primary"
                   v-if="hasBtnPermission('btn_jz_pm_dgwitness_busflow_configs_delete')"
                   @click="deleteSelectItem()">删除
        </el-button>
      </div>


      <el-table :data="tableData" ref="multipleTable"
                :height="tableMaxHeight"
                stripe border
                v-loading="dataListLoading"
                @selection-change="handleSelectionChange">
        <el-table-column fixed
                         label="序号"
                         type="index"
                         :index="indexMethod"
                         width="50"
                         align="center"></el-table-column>
        <el-table-column fixed type="selection" v-if="hasBtnPermission('btn_jz_pm_dgwitness_busflow_configs_delete')" align="center"
                         :show-overflow-tooltip='true'></el-table-column>
        <el-table-column fixed label="操作" align="center" width="100">
          <template slot-scope="scope">
            <el-button type="text" title="查看" v-if="hasBtnPermission('btn_jz_pm_dgwitness_busflow_configs_view')" @click="router(scope.row)">查看</el-button>
            <el-button type="text" title="删除" v-if="hasBtnPermission('btn_jz_pm_dgwitness_busflow_configs_delete')" @click="deleteById(scope.row)">
              删除
            </el-button>
          </template>
        </el-table-column>

        <el-table-column label="业务类型" prop='busTypeName' header-align="center" align="center" min-width='90'
                         :show-overflow-tooltip='true'>
          <template slot-scope="scope" >
            <el-tag v-if="scope.row.busType" :type="formatterTagType(scope.row.busType,'projectType')" size="small" :hit="false" effect="plain"  > {{scope.row.busTypeName}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="节点名称"
                         prop='nodeName'
                         header-align="center"
                         align="left"
                         min-width='200'
                         :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column label="节点编号"
                         prop='nodeCode'
                         header-align="center"
                         align="center"
                         min-width='100'
                         :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column label="分类节点"
                         prop='classNode'
                         header-align="center"
                         align="center"
                         min-width='120'
                         :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column label="开启预警" prop='warnEnable' header-align="center" align="center" min-width='80'
                         :show-overflow-tooltip='true'>
          <template slot-scope="scope" >
            <el-tag   size="small" :hit="false" effect="plain" :type="scope.row.warnEnable==0?'danger':'success'"  > {{scope.row.warnEnable==0?"关闭":"开启"}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="受理"
                         prop='enableHandle'
                         header-align="center"
                         align="center" min-width='60'
                         :show-overflow-tooltip='true'>
          <template slot-scope="scope" >
            <el-tag   size="small" :hit="false" effect="plain" :type="scope.row.enableHandle==0?'danger':'success'"  > {{scope.row.enableHandle==0?"否":"是"}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="支持自定义表单" prop='enableCustom' header-align="center" align="center" min-width='120'
                         :show-overflow-tooltip='true'>
          <template slot-scope="scope" >
            <el-tag   size="small" :hit="false" effect="plain" :type="scope.row.enableCustom==0?'danger':'success'"   > {{scope.row.enableCustom==0?"否":"是"}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="排序" prop='sort' header-align="center" align="center" min-width='80'
                         :show-overflow-tooltip='true'></el-table-column>
        <el-table-column label="数据集编码" prop='datasetCode' header-align="center" align="center" min-width='110'
                         :show-overflow-tooltip='true'></el-table-column>
        <el-table-column label="表单ID" prop='formId' header-align="center" align="center" min-width='160'
                         :show-overflow-tooltip='true'></el-table-column>
      </el-table>
      <!-- <el-pagination background
                     layout="sizes, prev, pager, next"
                     :page-sizes="[10, 20, 50, 100]"
                     :page-size="pageSize"
                     :total="total"
                     :current-page="pageIndex"
                     @size-change="sizeChangeHandle"
                     @current-change="currentChangeHandle"></el-pagination> -->
        <pagination
                class="limit"
                :page-sizes="[10, 20, 50, 100]"
                :total="total"
                :page.sync="pageIndex"
                :limit.sync="pageSize"
                @pagination="paginationChange">
        </pagination>  
    </div>
  </div>
</template>

<script>
  import {mapState} from "vuex";
  import Pagination from '@/components/Pagination.vue';

  export default {
    components:{
        Pagination
    },
  data() {
    return {
      tableMaxHeight: document.documentElement.clientHeight - 267,
      dataListLoading: false,
      form: {
        search:'' ,//搜索框的值
       // classNode: "",
        busType: "",
      },
      businessTypeNamelist: [],
      classNodelist: [],
      moreSearchItem: false,
      checkList1: '',
      pageSize: 10,//每页条数
      pageIndex: 1,//当前页
      total: 0,//总条数
      tableData: [],
      multipleSelection: [],
      user: '', //角色类型
      formData: {}
    }
  },
  computed: {
    ...mapState({
      stateData: state => state.user
    }),
  },
  filters: {
    ellipsis(text, num) {
      if (text.length > num) {
        return text.substring(0, num) + '...';
      } else {
        return text;
      }
    },
  },
  created() {
    this.getDic('jz_dgwitness_bustype');
    // this.getDic('jz_dgwitness_classnode');
  },
  activated() {
   // this.user = this.stateData.pageRoleIds //角色类型
    this.getDataList()
    // this.reflash()
  },
  mounted() {
    const that = this;
    let resizeTag = true
    window.onresize = () => {
      if (resizeTag) { //防抖动
        that.ifmove();
        resizeTag = false
        setTimeout(() => {
          resizeTag = true
        }, 1000)
      }
    }
    that.ifmove();
  },
  methods: {
    ifmove() {
      let hasBtnPermisson = this.hasBtnPermission('btn_jz_pm_dgwitness_busflow_configs_add') || this.hasBtnPermission('btn_jz_pm_dgwitness_busflow_configs_delete');
      let tableMaxHeight = document.documentElement.clientHeight - 328 + (hasBtnPermisson ? 0 : 33);
      this.pageSize = parseInt((tableMaxHeight) / 50) || 1;
      this.$nextTick(() => {
        this.tableMaxHeight = tableMaxHeight
      })
      // this.getDataList()
    },

    getDataList() { // 获取列表数据
      this.dataListLoading=true;
      this.$http.post('/configs/sysFlowNodeConfig/list', {
        'page': this.pageIndex,
        'rows': this.pageSize,
        'searchKey': this.form.search,
        'filter': this.form
      }).then(res => {
        this.tableData = res.data.rows;
        this.total = res.data.total;
        this.$refs.multipleTable.doLayout();
        this.dataListLoading=false;
      })
    },

    indexMethod(index) {
      return (this.pageIndex - 1) * this.pageSize + index + 1
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    seachBtn() { //搜索按钮
      this.pageIndex = 1;
      this.pageSize = 10;
      this.getDataList()
    },
    reflash() {//刷新按钮
      this.pageIndex = 1;
      this.$refs['form'].resetFields();
      this.form.search = "";
      this.form.busType = "";
    //  this.form.classNode = "";
      this.getDataList()

    },

    routerAdd(){ //新增
      window.sessionStorage.setItem("addUpdateIndex",2);

      window.sessionStorage.setItem("id", '');

      this.$router.push({
        name:'flownode_config_detail',
        query:{
          id:''
        }
      })

    },

    router(item){ // 跳转详情
      var id = item.id;
      this.$router.push({
        name:'flownode_config_view',
        query:{
          id:id
        }
      })

    },



    deleteById(item) {
      this.$confirm(`确定要删除该数据?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
      this.$http.post('/configs/sysFlowNodeConfig/delete', {
        id: item.id
      }).then(res => {
        if (res.data.code == '1') {
          this.$message({
            type: 'success',
            message: res.data.msg
          })
          this.getDataList();
        } else {
          this.$message({
            type: 'error',
            message: res.data.msg
          })
        }
      })
      })
    },
    deleteSelectItem() {
      let ids = new Array();
      this.multipleSelection.forEach(key => {
        ids.push(key.id)
      })

      if (ids != "" || ids.length > 0) {
        this.$http.post('/configs/sysFlowNodeConfig/delete', {
          idList: ids
        }).then(res => {
          if (res.data.code == '1') {
            this.$message({
              type: 'success',
              message: res.data.msg
            })
            this.getDataList();
          } else {
            this.$message({
              type: 'error',
              message: res.data.msg
            })
          }
        })
      } else {
        this.$message({
          type: 'error',
          message: "未选择删除项。"
        })
      }

    },

    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1
      this.getDataList()
    },

    currentChangeHandle(val) {
      this.pageIndex = val
      this.getDataList()
    },
    paginationChange(obj){
        this.pageIndex= obj.page||1
        this.pageSize=obj.limit||10
        this.getDataList();
        },
    getDic(type) { // 获取字典
      this.$http.get('/sys/dictData/getList?type=' + type).then(res => {
        if (res.data.code === '1') {
          switch (type) {
            case 'jz_dgwitness_bustype':this.businessTypeNamelist = res.data.data;break;
            case 'jz_dgwitness_bustype':this.classNodelist = res.data.data;break;
          }
        }
      })
    },

  }


}
</script>

<style lang="less">
.main_center {
  .top {
    .input_title {
      display: flex;
    }

    .el-form-item {
      margin-bottom: 0;
    }
  }
}

.margin-hide {
  .el-form-item__content {
    margin-left: 0 !important;
  }
}
</style>